<template>
    <div v-show="colorList" class="color-list-v3-panel">
        <div class="tools_headding catgory_headding w-100 add_txt">
            <h4 class="heading5">
                <a href="#" @click.prevent="closeEdit()" title="Back to clip settings"><svg class="mr_5" width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 1L1 6.5L6 12" stroke="#1D6CB5" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg></a> Available Colors ( {{ color_list.length }} )
            </h4>
            <a href="javascript:;" @click="closeEdit(), setBackValueReset()" title="Close" class="ml-auto"><img
                    src="/maincss/images/tool_close.svg" alt=" " /></a>
        </div>
        <div class="">
            <label v-show="colorListValue && colorListValue.length" class="current-colors-label">
                Current Colors ( {{ colorListValue.length }} )
            </label>
            <div v-show="colorListValue && colorListValue.length"
                class="ui-palette-box mb_20 present_color current_colors_row">
                <div v-for="(color, index) in colorListValue || []" :key="index" class="current_color_item">
                    <div class="marign_color current_color_swatch" :class="
                            (selectedColorIndex == index
                                ? ' selected_color '
                                : '') +
                            (setDefaultColor == color ? ' selected_color ' : '')
                        " @click="setActiveColor(color, index)" :style="'background:' + color + ';'"
                        v-tooltip="{ content: color, autoHide: false }"></div>
                    <span class="current_color_abbr">{{ getColorAbbreviation(color) }}</span>
                </div>
            </div>
            <AvailableColorsTabs
                v-if="color_list && color_list.length"
                :stock-colors="stockColors"
                :custom-ink-or-thread-colors="customColorsOnly"
                :specialty-colors="specialtyColors"
                :show-custom-ink-tab="showCustomInkTab"
                :show-custom-ink-or-thread-tab="showCustomInkOrThreadTab"
                :decoration-type="decorationType"
                :color-type="getServiceColorType"
                :selected-color="selectedColor"
                :selected-color-pms="selectedColorPms"
                :selected-color-id="selectedColorId"
                :color-list-value="colorListValue || []"
                @select="onTabSelectColor"
                @open-fullscreen="onOpenFullScreen"
            />
            <div
                v-show="color_list && color_list.length"
                class="color-list-extra-actions"
            >
                <div
                    v-if="isFullColorSelected"
                    ref="customPickerWrap"
                    class="marign_color color-picker-box-wrapper"
                >
                    <div
                        class="marign_color color-picker-box"
                        style="
                            position: relative;
                            width: 30px;
                            height: 30px;
                            border: 1px solid #ccc;
                            display: grid;
                            place-items: center;
                            cursor: pointer;
                        "
                        @click="toggleCustomPicker"
                    >
                        <!-- Eyedropper icon -->
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eyedropper"
                            viewBox="0 0 16 16"
                            style="color: #555; pointer-events: none"
                        >
                            <path
                                d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"
                            />
                        </svg>
                    </div>
                    <div ref="pickerWrapRef" class="color-list-v3-chrome-picker-wrap" :style="customPickerPosition">
                        <div v-show="showCustomPicker" class="custom-color-picker-container" @keydown.stop @keyup.stop @paste.stop @copy.stop>
                            <div class="color-picker-tabs">
                                <button
                                    :class="['color-picker-tab', { active: colorPickerMode === 'hex' }]"
                                    @click="colorPickerMode = 'hex'"
                                >
                                    HEX
                                </button>
                                <button
                                    :class="['color-picker-tab', { active: colorPickerMode === 'pms' }]"
                                    @click="colorPickerMode = 'pms'"
                                >
                                    PMS
                                </button>
                            </div>
                            <chrome-picker
                                v-show="colorPickerMode === 'hex'"
                                :value="customPickerColors"
                                @input="onCustomPickerInput"
                                class="color-list-v3-chrome-picker"
                            />
                            <div v-show="colorPickerMode === 'pms'" class="pms-input-container">
                                <div class="pms-input-wrapper">
                                    <label class="pms-label">Enter Pantone Code</label>
                                    <input
                                        v-model="pmsInput"
                                        type="text"
                                        class="pms-input"
                                        placeholder="e.g., 185 C"
                                        @keydown.enter.prevent="convertPMSToHex"
                                        @paste.stop
                                    />
                                    <button
                                        class="pms-convert-btn"
                                        @click="convertPMSToHex"
                                        :disabled="!pmsInput || isConvertingPMS"
                                    >
                                        {{ isConvertingPMS ? 'Converting...' : 'Convert' }}
                                    </button>
                                    <div v-if="pmsError" class="pms-error">
                                        {{ pmsError }}
                                        <button class="pms-error-close" @click="pmsError = null">×</button>
                                    </div>
                                    <div v-if="pmsConvertedColor" class="pms-preview">
                                        <div class="pms-preview-content">
                                            <div class="pms-preview-label">Applied:</div>
                                            <div class="pms-preview-swatch" :style="{ background: pmsConvertedColor }"></div>
                                            <div class="pms-preview-hex">{{ pmsConvertedColor }}</div>
                                        </div>
                                        <!-- <button class="pms-preview-close" @click="pmsConvertedColor = null" title="Clear">×</button> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="
                        changeColor(fabric_color), setActiveColor(fabric_color)
                    " class="febric_icon" title="Use Fabric Color"
                    :style="'display: grid; background:' + fabric_color + ';'">
                    <img v-if="fabric_color != '#000000'" src="/maincss/images/tshirt_icon_black.svg" alt="img" />
                    <img v-else src="/maincss/images/tshirt_icon_white.svg" alt="img" />
                    <div class="input_color_check_box">
                        <form>
                            <div class="form-group">
                                <span v-if="selectedColor == fabric_color"
                                    class="input_color_check_box_dot_icon"></span>
                                <input type="checkbox" :checked="selectedColor == fabric_color" />
                                <label for="html1"></label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ColorPickerFullScreen :visible="popupVisible" :title="popupTitle" :colors="popupColors"
                :selected-color="selectedColor" :selected-color-pms="selectedColorPms"
                :selected-color-id="selectedColorId" :color-list-value="colorListValue || []"
                :search-placeholder="'Search ' + (popupTitle || 'colors') + '...'" @select="onPopupSelectColor"
                @close="popupVisible = false" />
            <br />
        </div>
        <div>
            <div v-for="(unmatchedColor, unmatchedColorIndex) in unmatchedColors" :key="unmatchedColorIndex">
                <div class="bottom_color_block" v-if="
                        (decorationType != 0 && decorationType != '0') ||
                        ((decorationType == 0 || decorationType == '0') && getServiceName && typeof getServiceName === 'string' && (getServiceName.toLowerCase().includes('print') || getServiceName.toLowerCase().includes('embroidery') || getServiceName.toLowerCase().includes('emb')))
                    ">
                    <div class="ui-palette-box mb_20 present_color" style="
                            grid-template-columns: repeat(
                                auto-fill,
                                minmax(1.75rem, 1fr)
                            );
                            display: grid;
                            height: 28px;
                        ">
                        <span class="marign_color" :style="
                                'display: grid; background:' +
                                unmatchedColor +
                                ';'
                            "></span>
                    </div>
                    <span>Color(<b>{{ unmatchedColor }}</b>)
                        {{
                        decorationType == "1"
                        ? "Custom ink mix color"
                        : decorationType == "2"
                        ? "Custom thread color"
                        : decorationType == "0" && getServiceName && (getServiceName.toLowerCase().includes('print'))
                        ? "Custom ink mix color"
                        : decorationType == "0" && getServiceName &&
                        (getServiceName.toLowerCase().includes('embroidery') ||
                        getServiceName.toLowerCase().includes('emb'))
                        ? "Custom thread color"
                        : "Custom color"
                        }}
                        fee of
                        {{ icPriceFormat(non_standard_fees) }} applies</span>
                </div>
            </div>
        </div>
        <div class="save_btn_right">
            <a href="#" @click="closeEdit(), setBackValueReset()">Done</a>
        </div>
    </div>
</template>
    <script>
import commonData from "@/common/common.data";
import { mapGetters } from "vuex";
import { Chrome } from "vue-color";
import AvailableColorsTabs from "./AvailableColorsTabs.vue";
import ColorPickerFullScreen from "./ColorPickerFullScreen.vue";
import ApiService from "@/common/api.service";
export default {
    name: "ColorList",
    components: {
        "chrome-picker": Chrome,
        AvailableColorsTabs,
        ColorPickerFullScreen
    },
    props: [
        "colorList",
        "colorListValue",
        "value",
        "closeEdit",
        "showColorList",
        "checkDefaultValue",
        "canvasActiveObj",
        "selectedDefaultHex",
        "vendor_colors_list",
        "hasServiceColorType",
        "decorationType"
    ],
    data: () => {
        return {
            selectedColor: undefined,
            selectedColorPms: undefined,
            selectedColorId: undefined,
            product_data: [],
            color_list: [],
            fabric_color: "none",
            setDefaultColor: undefined,
            selectedColorIndex: 0,
            colourPath: {},
            unmatchedColors: [],
            non_standard_fees: 0,
            customColor: "#ff0000",
            customPickerColors: { hex: "#ff0000" },
            showCustomPicker: false,
            customPickerPosition: {
                top: "0px",
                left: "0px"
            },
            popupVisible: false,
            popupTitle: "",
            popupColors: [],
            colorPickerMode: 'hex',
            pmsInput: '',
            pmsConvertedColor: null,
            pmsError: null,
            isConvertingPMS: false,
            pickerWrapParent: null,
            pickerWrapNextSibling: null
        };
    },
    computed: {
        ...mapGetters(["adminOptions"]),
        // Get service name from localStorage design data
        getServiceName() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].activeServiceData) {
                        const activeServiceData = design[activeGenderKey].activeServiceData;
                        // Check master_service first
                        if (activeServiceData.master_service) {
                            return activeServiceData.master_service.name || activeServiceData.master_service.service_name || null;
                        }
                        // Fallback to name property
                        return activeServiceData.name || null;
                    }
                }
            } catch (e) {
                console.error('Error parsing design from localStorage:', e);
            }
            return null;
        },
        // Get color_type from service data
        getServiceColorType() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].activeServiceData) {
                        const activeServiceData = design[activeGenderKey].activeServiceData;
                        // Check master_service.color_type
                        if (activeServiceData.master_service && activeServiceData.master_service.color_type) {
                            return activeServiceData.master_service.color_type;
                        }
                    }
                }
            } catch (e) {
                console.error('Error getting color_type from localStorage:', e);
            }
            return '';
        },
        // Get vendor fees from localStorage design data
        getVendorFees() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].item && design[activeGenderKey].item.VendorFees) {
                        return design[activeGenderKey].item.VendorFees || [];
                    }
                }
            } catch (e) {
                console.error('Error parsing design from localStorage:', e);
            }
            return [];
        },
        // Check if service has full color enabled
        isFullColorSelected() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].activeServiceData) {
                        const activeServiceData = design[activeGenderKey].activeServiceData;
                        const isFullColor = activeServiceData.is_full_color === true;
                        return isFullColor;
                    }
                }
            } catch (e) {
                console.error('Error checking full color service:', e);
            }
            return false;
        },
        // Tab data: split color_list for Stock, Specialty, Custom Colors, and Ink/Thread tab
        stockColors() {
            if (!this.color_list || !this.color_list.length) return [];
            return this.color_list.filter((col) => {
                const stock = col.stock === true || col.stock === 1;
                const upcharge = parseFloat(col.decor_upcharge || 0);
                return stock && upcharge === 0;
            });
        },
        specialtyColors() {
            if (!this.color_list || !this.color_list.length) return [];
            return this.color_list.filter((col) => {
                const stock = col.stock === true || col.stock === 1;
                const upcharge = parseFloat(col.decor_upcharge || 0);
                return stock && upcharge > 0;
            });
        },
        customColorsOnly() {
            if (!this.color_list || !this.color_list.length) return [];
            return this.color_list.filter((col) => {
                const stock = col.stock === true || col.stock === 1;
                const upcharge = parseFloat(col.decor_upcharge || 0);
                
                // Exclude Stock colors (stock=true AND upcharge=0)
                if (stock && upcharge === 0) return false;
                
                // Exclude Specialty colors (stock=true AND upcharge>0)
                if (stock && upcharge > 0) return false;
                
                // Include everything else (custom ink/thread + common colors)
                return true;
            });
        },
        // Always show custom colors tab (even for color_type="none")
        showCustomInkOrThreadTab() {
            return true;
        },
        // true = show "Custom Ink Color" tab, false = show "Custom Thread Color" tab
        showCustomInkTab() {
            if (this.decorationType == 1 || this.decorationType === "1") return true;
            if (this.decorationType == 2 || this.decorationType === "2") return false;
            if ((this.decorationType == 0 || this.decorationType === "0") && this.getServiceName) {
                const name = (this.getServiceName || "").toLowerCase();
                if (name.includes("print")) return true;
                if (name.includes("embroidery") || name.includes("emb")) return false;
            }
            return true;
        }
    },
    watch: {
        selectedDefaultHex: function () {
            let colorIndex = this.colorListValue.findIndex(
                (colorHex) => colorHex == this.selectedDefaultHex
            );
            if (colorIndex >= 0) {
                this.selectedColorIndex = colorIndex;
                this.setDefaultColor = this.colorListValue[colorIndex];
                this.selectedColor = this.colorListValue[colorIndex];
            }
            let colorsIndex = this.color_list.findIndex(
                (colorHex) => colorHex.color_value == "#GGGGGG"
            );
            if (colorsIndex !== -1) this.color_list.splice(colorsIndex, 1);
            this.prepareUnmatchedColors();
            this.calculateNonStandardFees();
        },
        setDefaultColor: function (new_val, old_value) {
            if (this.checkDefaultValue) {
                this.setDefaultColor = new_val;
            }
            console.log(old_value);
        },
        colorListValue: function (e) {
            this.colourPath = {};
            this.selectedColor = "";
            let colorIndex = this.colorListValue.findIndex(
                (colorHex) => colorHex == this.selectedDefaultHex
            );
            if (colorIndex >= 0) {
                this.selectedColorIndex = colorIndex;
                this.setDefaultColor = this.colorListValue[colorIndex];
                this.selectedColor = this.colorListValue[colorIndex];
            }
            console.log(e);
        },
        getServiceName: function () {
            // Recalculate fees when serviceName changes (only for PCNA - type 0)
            if (this.decorationType == 0 || this.decorationType == "0") {
                this.calculateNonStandardFees();
            }
        },
        getVendorFees: function () {
            // Recalculate fees when vendorFees change
            if (this.decorationType !== undefined && this.decorationType !== null) {
                this.calculateNonStandardFees();
            }
        },
        decorationType: function () {
            // Recalculate fees when decorationType prop changes
            this.calculateNonStandardFees();
        },
        vendor_colors_list: function (newData, oldData) {
            if (newData != oldData) {
                this.color_list = newData;
                // Update Fabric Color
                this.$root.$on("active_tshirt_color", (colorCode) => {
                    let selected_fabric_color = this.fabric_color;
                    this.fabric_color = colorCode;
                    if (this.selectedColor == selected_fabric_color) {
                        this.changeColor(colorCode);
                        this.setActiveColor(colorCode);
                    }
                });
            }
        }
    },
    methods: {
        calculateNonStandardFees() {
            // Skip if decorationType is not available
            if (this.decorationType === undefined || this.decorationType === null) {
                this.non_standard_fees = 0;
                return;
            }
            
            // Get vendor fees from localStorage
            const vendorFees = this.getVendorFees || [];
            
            // If no vendor fees available, set fee to 0
            if (!Array.isArray(vendorFees) || vendorFees.length === 0) {
                this.non_standard_fees = 0;
                return;
            }
            
            let targetService = null;
            let feeValue = 0;
            
            if (this.decorationType == 1 || this.decorationType == "1") {
                // Screen Print - look for custom_ink_mix or ink mix fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "custom_ink_mix" ||
                        (service.ecomm_display &&
                            service.ecomm_display.toLowerCase().includes("ink mix fee")) ||
                        (service.name &&
                            service.name.toLowerCase().includes("ink mix fee"))
                );
            } else if (this.decorationType == 2 || this.decorationType == "2") {
                // Embroidery - look for thread_fee or thread mix fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "thread_fee" ||
                        (service.ecomm_display &&
                            service.ecomm_display.toLowerCase().includes("thread mix fee")) ||
                        (service.name &&
                            service.name.toLowerCase().includes("thread mix fee"))
                );
            } else if (this.decorationType == 0 || this.decorationType == "0") {
                // PCNA - check service name to determine if embroidery or print
                const serviceName = this.getServiceName;
                if (!serviceName || typeof serviceName !== 'string') {
                    // No service name found, no fee
                    targetService = null;
                } else {
                    const serviceNameLower = serviceName.toLowerCase();
                    const isEmbroidery = serviceNameLower.includes("embroidery") || serviceNameLower.includes("emb");
                    const isPrint = serviceNameLower.includes("print");
                    
                    if (isEmbroidery) {
                        // Look for thread_fee or thread mix fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display.toLowerCase().includes("thread mix fee")) ||
                                (service.name &&
                                    service.name.toLowerCase().includes("thread mix fee"))
                        );
                    } else if (isPrint) {
                        // Look for custom_ink_mix or ink mix fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display.toLowerCase().includes("ink mix fee")) ||
                                (service.name &&
                                    service.name.toLowerCase().includes("ink mix fee"))
                        );
                    } else {
                        // If neither embroidery nor print, no fee
                        targetService = null;
                    }
                }
            }
            
            // Get fee from vendor service
            if (targetService && targetService.retail_cost) {
                feeValue = parseFloat(targetService.retail_cost) || 0;
            }
            
            this.non_standard_fees = feeValue;
            this.$forceUpdate();
        },
        rgbToHex(rgbColorString) {
            if (rgbColorString.match(/^#([0-9a-f]{3}){1,2}$/i))
                return rgbColorString.toUpperCase();
            const rgbValues = rgbColorString.match(/\d+/g);
            if (!rgbValues || rgbValues.length != 3) {
                return rgbColorString.toLowerCase();
            }
            let r = parseInt(rgbValues[0], 10); // Red value
            let g = parseInt(rgbValues[1], 10); // Green value
            let b = parseInt(rgbValues[2], 10); // Blue value
            // Ensure that the values are within the valid range (0-255)
            r = Math.max(0, Math.min(255, r));
            g = Math.max(0, Math.min(255, g));
            b = Math.max(0, Math.min(255, b));
            // Convert each component to a hexadecimal string
            const redHex = r.toString(16).padStart(2, "0");
            const greenHex = g.toString(16).padStart(2, "0");
            const blueHex = b.toString(16).padStart(2, "0");
            // Combine the hexadecimal values to form the HEX color code
            const hexCode = `#${redHex}${greenHex}${blueHex}`;
            return hexCode.toUpperCase(); // Optional: Convert to uppercase for consistency
        },
        triggerLoaderGrandChild(currentStatus) {
            if (!currentStatus) {
                setTimeout(() => {
                    this.$emit("triggerLoaderGrandChild", currentStatus);
                }, 1000);
            } else {
                this.$emit("triggerLoaderGrandChild", currentStatus);
            }
        },
        prepareUnmatchedColors() {
            this.unmatchedColors = [];
            let activeTshirtColor = localStorage.getItem("active_tshirt_color");
            this.colorListValue.forEach((colorHex) => {
                let colorMatch = this.color_list.findIndex(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (
                    colorMatch == -1 &&
                    activeTshirtColor.toLowerCase() != colorHex.toLowerCase()
                ) {
                    this.unmatchedColors.push(colorHex);
                }
            });
        },
        prepareColors(colors) {
            let allColors = [];
            commonData.colorShades.forEach((shade) => {
                colors.forEach((color) => {
                    if (color.color_value && color.shades) {
                        if (color.shades.includes(shade)) {
                            let alreadyExisted = allColors.find(
                                (col) => col.color_id == color.color_id
                            );
                            if (!alreadyExisted) {
                                allColors.push(color);
                            }
                        }
                    }
                });
            });
            colors.forEach((color) => {
                if (color.color_value) {
                    if (!color.shades || color.shades.length == 0) {
                        allColors.push(color);
                    }
                }
            });
            return allColors;
        },
        setDefaultcolorHighlight() {},
        // Check if a color is selected - compares swatch_file/color_value, pms, and id
        isColorSelected(color) {
            if (!color) return false;
            
            // For swatch_file colors
            if (color.swatch_file) {
                // Check if swatch_file matches
                if (this.selectedColor !== color.swatch_file) {
                    return false;
                }
                // Also check PMS if available
                if (this.selectedColorPms !== undefined && color.color_pms !== undefined) {
                    if (this.selectedColorPms !== color.color_pms) {
                        return false;
                    }
                }
                // Also check color_id if available
                if (this.selectedColorId !== undefined && color.color_id !== undefined) {
                    if (this.selectedColorId !== color.color_id) {
                        return false;
                    }
                }
                return true;
            }
            
            // For regular colors (without swatch_file)
            // First check if color_value matches
            if (this.selectedColor !== color.color_value) {
                return false;
            }
            // Also check PMS if available (to distinguish colors with same hex but different PMS)
            if (this.selectedColorPms !== undefined && color.color_pms !== undefined) {
                if (this.selectedColorPms !== color.color_pms) {
                    return false;
                }
            }
            // Also check color_id if available
            if (this.selectedColorId !== undefined && color.color_id !== undefined) {
                if (this.selectedColorId !== color.color_id) {
                    return false;
                }
            }
            return true;
        },
        // Set active color with full details (pms, id, etc.)
        setActiveColorWithDetails(colorObj, color_index = null) {
            this.setDefaultColor = undefined;
            this.selectedColor = colorObj.swatch_file || colorObj.color_value;
            this.selectedColorPms = colorObj.color_pms;
            this.selectedColorId = colorObj.color_id;
            if (color_index != null) {
                this.selectedColorIndex = color_index;
            }
            this.$forceUpdate();
            var activeObject = this.canvasActiveObj.getActiveObject();
            if (this.colorListValue.length == 0 && activeObject) {
                activeObject.fill = colorObj.swatch_file || colorObj.color_value;
                activeObject.dirty = true;
                /* eslint-disable */
                this.canvasActiveObj.objectCaching = false;
                /* eslint-enable */
                this.canvasActiveObj.renderAll();
            }
        },
        setActiveColor(color, color_index = null) {
            this.setDefaultColor = undefined;
            this.selectedColor = color;
            // Reset pms and id when using simple color value
            this.selectedColorPms = undefined;
            this.selectedColorId = undefined;
            if (color_index != null) {
                this.selectedColorIndex = color_index;
            }
            this.$forceUpdate();
            var activeObject = this.canvasActiveObj.getActiveObject();
            if (this.colorListValue.length == 0 && activeObject) {
                activeObject.fill = color;
                activeObject.dirty = true;
                /* eslint-disable */
                this.canvasActiveObj.objectCaching = false;
                /* eslint-enable */
                this.canvasActiveObj.renderAll();
            }
        },
        toggleCustomPicker() {
            this.showCustomPicker = !this.showCustomPicker;
            if (this.showCustomPicker) {
                this.customPickerColors = { hex: this.rgbToHex(this.customColor || "#ff0000") };
                // Reset PMS mode when opening
                this.colorPickerMode = 'hex';
                this.pmsInput = '';
                this.pmsConvertedColor = null;
                this.pmsError = null;
                this.$nextTick(() => {
                    // Position with viewport coords; move picker to body so position:absolute is not clipped.
                    const wrap = this.$refs.customPickerWrap;
                    const pickerWrap = this.$refs.pickerWrapRef;
                    if (wrap && pickerWrap && wrap.getBoundingClientRect) {
                        const rect = wrap.getBoundingClientRect();
                        const margin = 4;
                        const pickerWidth = 280;
                        const pickerHeight = 380;

                        const spaceBelow = window.innerHeight - rect.bottom - margin;
                        const showAbove = spaceBelow < pickerHeight;

                        const minTopFromViewport = 100;
                        let top;
                        if (showAbove) {
                            // Place so picker bottom touches button top; keep at least 100px from viewport top
                            top = Math.max(minTopFromViewport, rect.top - pickerHeight);
                        } else {
                            top = rect.bottom + margin;
                        }

                        let left = rect.left;
                        if (left + pickerWidth > window.innerWidth - margin) {
                            left = window.innerWidth - pickerWidth - margin;
                        }
                        if (left < margin) {
                            left = margin;
                        }

                        this.customPickerPosition = {
                            top: top + "px",
                            left: left + "px"
                        };

                        // Move picker to body so position:absolute is viewport-relative and never clipped
                        this.pickerWrapParent = pickerWrap.parentNode;
                        this.pickerWrapNextSibling = pickerWrap.nextSibling;
                        document.body.appendChild(pickerWrap);
                    }

                    document.addEventListener("click", this.documentClickCustomPicker);
                });
            } else {
                this.movePickerBackToTrigger();
                document.removeEventListener("click", this.documentClickCustomPicker);
            }
        },
        movePickerBackToTrigger() {
            const pickerWrap = this.$refs.pickerWrapRef;
            if (pickerWrap && this.pickerWrapParent) {
                if (this.pickerWrapNextSibling) {
                    this.pickerWrapParent.insertBefore(pickerWrap, this.pickerWrapNextSibling);
                } else {
                    this.pickerWrapParent.appendChild(pickerWrap);
                }
                this.pickerWrapParent = null;
                this.pickerWrapNextSibling = null;
            }
        },
        documentClickCustomPicker(e) {
            const wrap = this.$refs.customPickerWrap;
            const pickerWrap = this.$refs.pickerWrapRef;
            const inTrigger = wrap && wrap.contains(e.target);
            const inPicker = pickerWrap && pickerWrap.contains(e.target);
            if (!inTrigger && !inPicker) {
                this.showCustomPicker = false;
                document.removeEventListener("click", this.documentClickCustomPicker);
                this.movePickerBackToTrigger();
            }
        },
        onCustomPickerInput(color) {
            this.customPickerColors = color;
            const hex = color.hex || this.customColor;
            this.customColor = hex;
            this.changeColor(hex);
            this.setActiveColor(hex);
        },
        async convertPMSToHex() {
            if (!this.pmsInput || !this.pmsInput.trim()) {
                this.pmsError = 'Please enter a Pantone code';
                return;
            }

            this.isConvertingPMS = true;
            this.pmsError = null;
            this.pmsConvertedColor = null;

            try {
                const response = await ApiService.post('/get-hex-from-pms', {
                    pms: this.pmsInput.trim()
                });

                // API returns: { success: true, pms: "7A6D5E" }
                if (response.data && response.data.success && response.data.pms) {
                    let hexColor = response.data.pms;
                    // Add # if not present
                    if (!hexColor.startsWith('#')) {
                        hexColor = '#' + hexColor;
                    }
                    this.pmsConvertedColor = hexColor;
                    this.customColor = hexColor;
                    
                    // Apply the color
                    this.changeColor(hexColor);
                    this.setActiveColor(hexColor);
                    
                    // Clear input field only (keep preview visible)
                    this.pmsInput = '';
                } else {
                    // Show specific error message from API if available
                    const errorMsg = response.data && response.data.message 
                        ? response.data.message 
                        : 'Could not convert Pantone code.';
                    this.pmsError = errorMsg;
                }
            } catch (error) {
                console.error('PMS conversion error:', error);
                // Show API error message if available
                const errorMsg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error converting Pantone code. Please try again.';
                this.pmsError = errorMsg;
            } finally {
                this.isConvertingPMS = false;
            }
        },
        changeColor(e) {
            if (e == null) {
                return false;
            }
            let color = e;
            let _this = this;
            _this.triggerLoaderGrandChild(true);
            /* eslint-disable */
            if (_this.selectedColor) {
                var activeObject = _this.canvasActiveObj.getActiveObject();
                if (activeObject) {
                    if (activeObject._objects && activeObject._objects.length) {
                        let localColPathArr = [];
                        let pathLength = 0;
                        if (Object.keys(_this.colourPath).length === 0) {
                            _this.colorListValue.forEach(function (val, ind) {
                                let localPathArr = [];
                                activeObject._objects.forEach(function (
                                    e,
                                    index
                                ) {
                                    if (
                                        _this.rgbToHex(val) ==
                                        _this.rgbToHex(e.fill)
                                    ) {
                                        localPathArr.push(index);
                                        e.fill = _this.rgbToHex(e.fill);
                                    }
                                    if (
                                        activeObject._objects.length - 1 ==
                                        index
                                    ) {
                                        localColPathArr[val] = localPathArr;
                                    }
                                });
                                if (_this.colorListValue.length - 1 == ind) {
                                    _this.colourPath = localColPathArr;
                                }
                            });
                            pathLength = _this.colourPath.length;
                        }
                        let noOfKey = Object.keys(_this.colourPath).filter(
                            (key) => key.includes("@")
                        );
                        let noOfWord = "";
                        let localColor = _this.rgbToHex(color);
                        let localSelectedColor = _this.rgbToHex(
                            _this.selectedColor
                        );
                        for (let [index, e] of Object.entries(
                            activeObject._objects
                        )) {
                            index = parseInt(index);
                            if (
                                _this.colourPath.hasOwnProperty(
                                    localSelectedColor
                                )
                            ) {
                                if (
                                    localSelectedColor ==
                                        _this.rgbToHex(e.fill) &&
                                        _this.colourPath[
                                            localSelectedColor
                                        ].includes(index)
                                    )
                                        e.fill = localColor;
                                } else if (noOfKey.length > 0) {
                                    noOfWord = "";
                                    for (let member in noOfKey) {
                                        noOfWord += "@";
                                    }
                                    if (
                                        localSelectedColor ==
                                        _this.rgbToHex(e.fill) &&
                                        _this.colourPath[
                                            localSelectedColor + noOfWord
                                        ].includes(index)
                                    )
                                        e.fill = localColor;
                                } else {
                                    if (
                                        localSelectedColor ==
                                        _this.rgbToHex(e.fill) &&
                                        !_this.colourPath[
                                            localSelectedColor
                                        ].includes(index)
                                    )
                                        e.fill = localColor;
                                }
                                if (activeObject._objects.length - 1 == index) {
                                    let outPut = Object.keys(
                                        _this.colourPath
                                    ).filter((key) => key.includes(localColor));
                                    let indexText = "";
                                    if (outPut.length > 0) {
                                        for (let member in outPut) {
                                            indexText += "@";
                                        }
                                    }
                                    if (localColor in _this.colourPath) {
                                        let currentPaths =
                                            _this.colourPath[localSelectedColor];
                                        delete _this.colourPath[localSelectedColor];
                                        _this.colourPath[localColor + indexText] =
                                            currentPaths;
                                    } else if (
                                        localSelectedColor in _this.colourPath
                                    ) {
                                        let currentPaths =
                                            _this.colourPath[localSelectedColor];
                                        delete _this.colourPath[localSelectedColor];
                                        _this.colourPath[localColor] = currentPaths;
                                    } else if (noOfKey.length > 0) {
                                        let currentPaths =
                                            _this.colourPath[
                                            localSelectedColor + noOfWord
                                        ];
                                    delete _this.colourPath[
                                        localSelectedColor + noOfWord
                                    ];
                                    _this.colourPath[localColor] = currentPaths;
                                }
                            }
                        }
                        _this.selectedColor = localColor;
                        
                        // Handle stroke (outline) if selectedColorIndex is 1
                        if (_this.selectedColorIndex === 1 && activeObject.ctype === 'shape') {
                            // Update stroke for outline color
                            activeObject.set({
                                stroke: localColor,
                                strokeWidth: activeObject.strokeWidth || 3,
                                strokeLineCap: 'round',
                                strokeLineJoin: 'round'
                            });
                            // Update stroke for each path in _objects
                            activeObject._objects.forEach(function(obj) {
                                obj.set({
                                    stroke: localColor,
                                    strokeWidth: obj.strokeWidth || 3,
                                    strokeLineCap: 'round',
                                    strokeLineJoin: 'round'
                                });
                            });
                        }
                        
                        // for one canvas
                        _this.colorListValue[this.selectedColorIndex] =
                            localColor;
                        _this.canvasActiveObj.objectCaching = false;
                        // for all canvas
                        _this.canvasActiveObj.renderAll();
                        _this.$emit("undoAndRedoImageColor");
                        _this.showColorList();
                    } else {
                        // For simple shapes or when _objects is not present, use setValue
                        // This will properly handle fill vs outline based on selectedColorIndex
                        _this.setValue(color);
                    }
                }
            } else this.setValue(color);
            /* eslint-enable */
            this.selectedColor = color;
            this.prepareUnmatchedColors();
            _this.triggerLoaderGrandChild(false);
        },
        setValue(e) {
            this.$emit("set-value", e, this.selectedColor, this.selectedColorIndex);
        },
        setBackValueReset() {
            this.selectedColorIndex = 0;
            this.selectedColorPms = undefined;
            this.selectedColorId = undefined;
        },
        onTabSelectColor(color) {
            const val = color.swatch_file || color.color_value;
            this.changeColor(val);
            this.setActiveColorWithDetails(color);
        },
        onOpenFullScreen({ title, colors }) {
            this.popupTitle = title || "Colors";
            this.popupColors = colors || [];
            this.popupVisible = true;
        },
        onPopupSelectColor(color) {
            this.onTabSelectColor(color);
            this.popupVisible = false;
        },
        /**
         * When color type is none: only show abbreviation if color is in vendor list.
         * When color type is set: always show abbreviation.
         */
        shouldShowColorAbbreviation(colorHex) {
            if (this.hasServiceColorType !== false) return true;
            if (!colorHex || !this.color_list || !this.color_list.length) return false;
            return this.color_list.some(
                (col) =>
                    (col.color_value || "").toLowerCase() ===
                    (colorHex || "").toLowerCase()
            );
        },
        /**
         * Returns abbreviation for color type: S (Stock), SP (Specialty), CT (Custom Thread), CI (Custom Ink)
         */
        getColorAbbreviation(colorHex) {
            if (!colorHex || !this.color_list || !this.color_list.length) {
                return this.getCustomTypeAbbreviation();
            }
            const vendorColor = this.color_list.find(
                (col) =>
                    (col.color_value || "").toLowerCase() ===
                    (colorHex || "").toLowerCase()
            );
            if (!vendorColor) {
                return this.getCustomTypeAbbreviation();
            }
            const stock =
                vendorColor.stock === true || vendorColor.stock === 1;
            const upcharge = parseFloat(vendorColor.decor_upcharge || 0);
            if (stock && upcharge === 0) return "S";
            if (stock && upcharge > 0) return "SP";
            if (!stock) return this.getCustomTypeAbbreviation();
            return this.getCustomTypeAbbreviation();
        },
        getCustomTypeAbbreviation() {
            if (
                this.decorationType == 1 ||
                this.decorationType === "1"
            ) {
                return "CI";
            }
            if (
                this.decorationType == 2 ||
                this.decorationType === "2"
            ) {
                return "CT";
            }
            if (
                (this.decorationType == 0 || this.decorationType === "0") &&
                this.getServiceName
            ) {
                const name = (this.getServiceName || "").toLowerCase();
                if (name.includes("print")) return "CI";
                if (name.includes("embroidery") || name.includes("emb"))
                    return "CT";
            }
            // If no color type (e.g., Laser service), return "C" for Custom
            if (this.hasServiceColorType === false) {
                return "CC";
            }
            return "CI";
        }
    },
    mounted() {
        this.fabric_color = localStorage.getItem("active_tshirt_color");
        // Set default color if swatches in the select color
        if (this.fabric_color == "null") {
            this.fabric_color = "#d3d3d3";
        }
        if (this.vendor_colors_list.length > 0) {
            let colorIndex = this.vendor_colors_list.findIndex(
                (colorHex) => colorHex.color_value == "#GGGGGG"
            );
            /* eslint-disable */
            if (colorIndex !== -1)
                this.vendor_colors_list.splice(colorIndex, 1);
            this.color_list = this.vendor_colors_list;
            /* eslint-enable */
            // Update Fabric Color
            this.$root.$on("active_tshirt_color", (colorCode) => {
                let selected_fabric_color = this.fabric_color;
                this.fabric_color = colorCode;
                if (this.selectedColor == selected_fabric_color) {
                    this.changeColor(colorCode);
                    this.setActiveColor(colorCode);
                }
            });
        }
        // Calculate fees on mount
        this.$nextTick(() => {
            this.calculateNonStandardFees();
        });
    },
    beforeDestroy() {
        document.removeEventListener("click", this.documentClickCustomPicker);
        this.movePickerBackToTrigger();
    }
};
</script>
<style>
    .color-list-v3-panel .heading5 {
        color: #000000 !important;
        font-size: 20px !important;
        line-height: 24px;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .current_colors_row {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 16px;
        align-items: flex-start;
        margin-bottom: 16px;
    }

    .current_color_item {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .current_color_swatch {
        width: 28px;
        min-width: 28px;
        cursor: pointer;
        position: relative;
    }

    .current_color_abbr {
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        color: #121212;
        text-transform: uppercase;
        background-color: #fff;
        width: 32px;
        height: 18px;
        text-align: center;
        padding-top: 2px;
    }

    .color-list-extra-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        margin-top: 8px;
    }

    .marign_color {
        margin: 0px;
        border: 1px solid rgb(73, 70, 70);
    }

    .marign_color:hover {
        margin: 0px;
    }

    .design_studio_tool .ui-palette-box.present_color .marign_color.selected_color,
    .design_studio_tool .current_color_swatch.selected_color {
        border: 1px solid #0079c1 !important;
    }

    .design_studio_tool .ui-palette-box.present_color .marign_color.selected_color:after,
    .design_studio_tool .current_color_item .current_color_swatch.selected_color:after {
        content: "";
        width: 34px;
        display: block;
        background: #0079c1;
        height: 2px;
        position: absolute;
        bottom: -23px;
        z-index: 9;
    }

    .color-picker-box {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        overflow: hidden;
    }

    .bottom_color_block {
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }

    .bottom_color_block .present_color {
        margin-bottom: 10px;
    }

    .save_btn_right a {
        background-color: #fff !important;
        height: 44px;
        display: flex;
        align-items: center;
        border-radius: 4px;
    }

    .bottom_color_block span {
        color: #212529;
        font-size: 14px;
        line-height: 14px;
    }

    /* Anchor trigger; picker itself is positioned with fixed coords via customPickerPosition */
    .color-picker-box-wrapper {
        position: relative;
        display: inline-block;
        z-index: 1000;
    }

    .color-list-v3-chrome-picker-wrap {
        position: absolute;
        z-index: 1;
    }

    .color-list-v3-chrome-picker {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
    .vc-chrome-fields .vc-input__input{
        font-size: 16px !important;
    }
    .vc-chrome-fields .vc-input__label{
        font-size: 16px !important;
    }

    /* Custom Color Picker Tabs */
    .custom-color-picker-container {
        background: #fff !important;
        border-radius: 4px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
        overflow: hidden !important;
        min-width: 225px !important;
    }

    .color-picker-tabs {
        display: flex !important;
        border-bottom: 1px solid #e0e0e0 !important;
        background: #f5f5f5 !important;
        width: 100% !important;
    }

    .color-picker-tab {
        flex: 1 1 0% !important;
        min-width: 0 !important;
        padding: 10px 16px !important;
        background: transparent !important;
        border: none !important;
        cursor: pointer !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #666 !important;
        transition: all 0.2s ease !important;
        outline: none !important;
        box-sizing: border-box !important;
    }

    .color-picker-tab:hover {
        background: rgba(0, 121, 193, 0.1) !important;
        color: #0079c1 !important;
    }

    .color-picker-tab.active {
        background: #fff !important;
        color: #0079c1 !important;
        border-bottom: 2px solid #0079c1 !important;
        font-weight: 600 !important;
        padding-bottom: 5px !important;
    }

    /* PMS Input Container */
    .pms-input-container {
        padding: 20px !important;
        background: #fff !important;
        min-height: auto !important;
        width: 225px;
    }

    .pms-input-wrapper {
        display: flex !important;
        flex-direction: column !important;
        gap: 12px !important;
    }

    .pms-label {
        font-size: 14px !important;
        font-weight: 600 !important;
        color: #333 !important;
        margin-bottom: 4px !important;
    }

    .pms-input {
        width: 100% !important;
        padding: 12px 14px !important;
        border: 2px solid #ccc !important;
        border-radius: 4px !important;
        font-size: 15px !important;
        font-weight: 500 !important;
        outline: none !important;
        transition: all 0.2s ease !important;
        background: #fff !important;
    }

    .pms-input:focus {
        border-color: #0079c1 !important;
        box-shadow: 0 0 0 3px rgba(0, 121, 193, 0.15) !important;
        background: #f8fcff !important;
    }

    .pms-input::placeholder {
        color: #999 !important;
        font-weight: 400 !important;
    }

    .pms-input-wrapper .pms-convert-btn,
    .pms-convert-btn {
        height: 32px;
        padding: 6px 12px !important;
        background-color: #0079c1 !important;
        background: #0079c1 !important;
        color: #fff !important;
        border: none !important;
        border-radius: 4px !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        cursor: pointer !important;
        transition: all 0.2s ease !important;
        outline: none !important;
        box-shadow: 0 2px 4px rgba(0, 121, 193, 0.2) !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
    }

    .pms-input-wrapper .pms-convert-btn:hover:not(:disabled),
    .pms-convert-btn:hover:not(:disabled) {
        background-color: #005a8f !important;
        background: #005a8f !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 4px 12px rgba(0, 121, 193, 0.4) !important;
    }

    .pms-input-wrapper .pms-convert-btn:active:not(:disabled),
    .pms-convert-btn:active:not(:disabled) {
        transform: translateY(0) !important;
        box-shadow: 0 2px 4px rgba(0, 121, 193, 0.2) !important;
    }

    .pms-input-wrapper .pms-convert-btn:disabled,
    .pms-convert-btn:disabled {
        background-color: #b0bec5 !important;
        background: #b0bec5 !important;
        cursor: not-allowed !important;
        opacity: 0.7 !important;
        box-shadow: none !important;
    }

    .pms-error {
        position: relative !important;
        padding: 8px 32px 8px 12px !important;
        background: #ffe5e5 !important;
        color: #d32f2f !important;
        border-left: 3px solid #d32f2f !important;
        border-radius: 4px !important;
        font-size: 13px !important;
    }

    .pms-error-close {
        position: absolute !important;
        top: 4px !important;
        right: 8px !important;
        background: transparent !important;
        border: none !important;
        color: #d32f2f !important;
        font-size: 20px !important;
        line-height: 1 !important;
        cursor: pointer !important;
        padding: 0 !important;
        width: 20px !important;
        height: 20px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    .pms-error-close:hover {
        color: #b71c1c !important;
    }

    .pms-preview {
        position: relative !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding: 12px !important;
        background: transparent!important;
        border-radius: 4px !important;
        border: 1px solid #0079c1 !important;
    }

    .pms-preview-content {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        flex: 1 !important;
    }

    .pms-preview-label {
        font-size: 13px !important;
        font-weight: 600 !important;
        color: #0079c1  !important;
    }

    .pms-preview-swatch {
        width: 20px !important;
        height: 20px !important;
        border-radius: 4px !important;
        border: 1px solid #ccc !important;
    }

    .pms-preview-hex {
        font-size: 14px !important;
        font-weight: 600 !important;
        color: #0079c1 !important;
        font-family: monospace !important;
    }

    .pms-preview-close {
        background: transparent !important;
        border: none !important;
        color: #0079c1  !important;
        font-size: 24px !important;
        line-height: 1 !important;
        cursor: pointer !important;
        padding: 0 !important;
        width: 24px !important;
        height: 24px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-shrink: 0 !important;
    }

    .pms-preview-close:hover {
        color: #0079c1  !important;
        background: #fff !important;
        border-radius: 50% !important;
    }
</style>